import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Api from 'utils/api';
import titleize from 'utils/titleize';

class BusinessDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = { organisation: null };
  };

  componentWillMount = () => {
    const api = new Api({ baseUrl: 'http://localhost:3001/api' });
    api.fetchCompanyInfo()
      .then((organisation) => {
        this.setState({ organisation });
      });
  };

  renderOrganisation = (organisation) => {
    return Object.keys(organisation).map(key => {
      return (
        key !== 'addresses' && key !== 'phones' &&
          <TableRow key={key}>
            <TableCell>
              {titleize(key)}
            </TableCell>
            <TableCell>
              {organisation[key]}
            </TableCell>
          </TableRow>
      );
    });
  }

  renderLoader = () => {
    return (
      <TableRow style={{textAlign: 'center'}}>
      </TableRow>
    );
  }

  renderBody = () => {
    const { organisation } = this.state;

    if (organisation) {
      return this.renderOrganisation(organisation);
    } else {
      return this.renderLoader();
    }
  }

  render = () => {
    return (
      <Table>
        <TableBody>
          { this.renderBody() }
        </TableBody>
      </Table>
    )
  }
}

export default BusinessDetails;



// WEBPACK FOOTER //
// ./src/components/BusinessDetails/index.js